export enum TellentMembersStoreKey {
  TellentMembers = 'TellentMembers',
  TellentApps = 'TellentApps',
}

export type TransferOwnershipPayload = {
  memberGuid: string;
  code: string;
};

export type CreateSeatPayload = {
  access: boolean;
  active: true;
  appGuid: string;
  memberGuid: string;
  roleExternalId: string;
};

export type UpdateSeatPayload = {
  access: boolean;
  active: boolean;
  guid: string;
  roleExternalId: string;
};

export type DeactivateSeatPayload = {
  active: false;
  guid: string;
};

export type SeatPayload = CreateSeatPayload | UpdateSeatPayload | DeactivateSeatPayload;

export type ManageSeatsPayload = {
  seats: SeatPayload[];
};
